<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="地区：">
                    <el-radio-group v-model.trim="formInline.region" @change="search">
                        <el-radio v-for="item in regionList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Payers：" v-if="curRole=='admin'||curRole=='superadmin'">
                    <el-select v-model="formInline.payer_id" clearable filterable style="width:200px" @change="search" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in payersList"
                            :key="index"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="LinkerId：" v-if="curRole!='customer'">
                    <el-input v-model="formInline.link_id" clearable style="width:200px" @change="search" placeholder="请输入LinkerId"></el-input>   
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker 
                        @change="search"
                        format="YYYY-MM"
                        value-format="YYYYMM"
                        v-model="formInline.month"
                        type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item v-if="selected.length>0" label=""><el-button  @click="lock()" icon="lock">锁定账单</el-button></el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" @selection-change="selectionChange" style="width: 100%">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="LinkedAccountId" label="LinkerId">
                    <template #default="scope">
                        <span v-if="curRole=='customer'">{{ scope.row.LinkedAccountId }}</span>
                        <span style="cursor:pointer" v-else @click="getLinkersList(scope.row.LinkedAccountId)">{{ scope.row.LinkedAccountId }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总代返点状态" v-if="curRole!='customer'">
                    <template #default="scope">
                        <span v-if="scope.row.discount1>0&&(scope.row.discount1<scope.row.discount)" style="color:red;font-weight:bold;">返点异常</span>
                        <span v-else style="color:green;font-weight:bold;">正常</span>
                    </template>
                </el-table-column>
                <el-table-column label="二代返点状态" v-if="curRole!='customer'">
                    <template #default="scope">
                        <span v-if="scope.row.discount2>0&&(scope.row.discount2<scope.row.discount_agent)" style="color:red;font-weight:bold;">返点异常</span>
                        <span v-else style="color:green;font-weight:bold;">正常</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否超预算" v-if="curRole!='customer'">
                    <template #default="scope">
                        <span v-if="scope.row.budget&&Number(scope.row.TotalCost)>Number(scope.row.budget)" style="color:red;font-weight:bold;">超预算</span>
                        <span v-else-if="scope.row.budget==null||scope.row.budget==''" style="color:red;font-weight:bold;"></span>
                        <span v-else style="color:green;font-weight:bold;">正常</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否收款" v-if="curRole=='admin'||curRole=='superadmin'">
                    <template #default="scope">
                        <el-switch
                            v-if="!scope.row.isrecv&&!isCurMonth"
                            :disabled="!scope.row.canEdit"
                            v-model="scope.row.isrecv"
                            size="large"
                            active-text=""
                            :before-change="changeStatus.bind(this,scope.row)"
                            :inactive-text="scope.row.deadline<curDate?'已逾期':'待收款'"
                        />
                        <span v-else-if="isCurMonth&&!scope.row.isrecv">待收款</span>
                        <span v-else>已收款</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否支付" v-if="curRole=='admin'||curRole=='superadmin'">
                    <template #default="scope">
                        <el-switch
                            v-if="!scope.row.ispaid&&!isCurMonth"
                            :disabled="!scope.row.canEdit"
                            v-model="scope.row.ispaid"
                            :before-change="changeStatus1.bind(this,scope.row)"
                            size="large"
                            active-text=""
                            :inactive-text="scope.row.deadline<curDate?'已逾期':'待支付'"
                        />
                        <span v-else-if="isCurMonth&&!scope.row.ispaid">待支付</span>
                        <span v-else>已支付</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否锁定" v-if="curRole!='agent'&&curRole!='customer'">
                    <template #default="scope">{{ scope.row.locked==1?'已锁定':'' }}</template>
                </el-table-column>
                <!-- <el-table-column prop="TotalCost" label="原始金额">
                    <template #default="scope">{{Math.round(Number(scope.row.TotalCost)*100)/100}}</template>
                </el-table-column> -->
                <el-table-column label="应付金额">
                    <template #default="scope">
                        <div v-if="curRole=='customer'">
                            {{Math.round(Number(scope.row.CostBeforeTax)*100)/100}}
                        </div>
                        <div v-else-if="curRole=='agent'">
                            {{Math.round(Number(scope.row.CostBeforeTax)*(1-Number(scope.row.discount2))*100)/100}}
                        </div>
                        <div v-else>
                            {{Math.round(Number(scope.row.ToPay)*100)/100}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ToPay" label="使用金额">
                    <template #default="scope">
                        {{Math.round(Number(scope.row.CostBeforeTax)*100)/100}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" :width="(curRole=='admin'||curRole=='superadmin')?360:100">
                    <template #default="scope">
                        <div v-if="curRole=='admin'||curRole=='superadmin'">
                            <el-button size="small" type="primary" :disabled="!scope.row.canEdit" @click="adjust(scope.row)">调整返点</el-button>
                            <el-button size="small" type="primary" v-if="!isCurMonth" :disabled="!scope.row.canLocked" @click="lock(scope.row)">锁定账单</el-button>
                            <el-button size="small" type="primary" :disabled="!scope.row.canEdit" @click="adjustBudget(scope.row)">调整预算</el-button>
                            <el-button size="small" type="primary" :disabled="!scope.row.canEdit" @click="preview(scope.row)">预览账单</el-button>
                        </div>
                        <div v-else>
                            <el-button size="small" type="primary" :disabled="!scope.row.canEdit" @click="preview(scope.row)">预览账单</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <el-dialog v-model="dialogVisible" :close-on-click-modal="false" title="调整返点" :before-close="cancel">
            <el-form :inline="false" :model="formData" ref="rulesForm" label-position="right" label-width="auto">         
                <el-form-item label="预估总代返点：" prop="discount">
                    <el-input v-model="formData.discount" disabled></el-input>
                </el-form-item>
                <el-form-item label="实际总代返点：" prop="discount">
                    <el-input v-model="formData.discount1" @input="(v)=>(formData.discount1=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"></el-input>
                </el-form-item>
                <el-form-item label="实际二代返点：" prop="discount2">
                    <el-input v-model="formData.discount2" @input="(v)=>(formData.discount2=v.replace(/[^\d.]/g,''))" placeholder="请输入小数点后两位，如0.25"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="budgetVisible" :close-on-click-modal="false" title="调整Linker预算" width="560px" :before-close="cancel">
            <el-form :inline="false" :model="formData1" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="LinkerId：" prop="link_id">
                    <el-input v-model="formData1.link_id"></el-input>
                </el-form-item>
                <el-form-item label="预算：" prop="budget">
                    <el-input type="number" v-model="formData1.budget"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="editSubmit(formData1.id)">确定</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="linkerVisible" title="Linker详情" width="900px" class="link-dialog">
            <el-form ref="rulesForm" label-position="right" label-width="100">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区：" prop="region">
                            {{ linkerList[0].region=='cn'?'中国':'Global' }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户名称：" prop="company">
                            {{ linkerList[0].company }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="LinkerId：" prop="link_id">
                            {{ linkerList[0].link_id }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="PayerId：" prop="payer_id">
                            {{ linkerList[0].payer_id }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="伙伴：" prop="agent_id">
                            {{ agentMap.get(linkerList[0].agent_id) }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="销售：" prop="sales">
                            {{ linkerList[0].sales }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="邮箱：" prop="email">
                            {{ linkerList[0].email }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总代返点：" prop="discount">
                            {{ linkerList[0].discount }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="伙伴返点：" prop="discount_agent">
                            {{ linkerList[0].discount_agent }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="预算：" prop="budget">
                            {{ linkerList[0].budget }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getLinkers,getBillList,getPayerList,getLinkerList,getRebate,adjustRebate,addRebate,lockBill,setBillPaid,setBillRecv,editLinker,reCalcBill,setBillBudget,getBillDetail,sendZhangdan,getAgentList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import { downloadUrl } from '../../api/url';
    export default {
        components:{
            Pagination
        },
        name:'billList',
        data() {
            return {
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    region:'cn',
                    month:'',
                    page: 1,
                    limit: 20,
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payersList:[],
                curDate:'',
                selected:[],
                dialogVisible:false,
                budgetVisible:false,
                formData:{
                    discount:0,
                    discount_agent:0,
                    discount1:0,
                    discount2:0
                },
                formData1:{
                    link_id:'',
                    id:'',
                    budget:''
                },
                curLinkId:'',
                linkerList:[],
                curRole:localStorage.getItem('curRole'),
                curBillId:'',
                linkerVisible:false,
                
                regionList:[
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                isCurMonth:true,
                billVisible:false,
                billDetail:null,
                curItem:null,
                agentsList:[],
                agentMap:null,
                arrCn:[],
                arrGlobal:[]
            }
        },
        
        created() {
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            let endD = date.getDate()<10?'0'+date.getDate():date.getDate();
            // 获取当前时间的时间戳
            this.curDate=(new Date(endY+'-'+endM+'-'+endD).getTime())/1000;
            this.formInline.month=endY+endM;
            this.isCurMonth=true;
            this.getPayersList();
            this.getLinkersList();
            if(this.curRole=='agent'){
                var timer=setInterval(() => {
                    if(this.payersList.length>0){
                        var num=0;
                        clearInterval(timer)
                        for(var i=0;i<this.payersList.length;i++){
                            if(this.payersList[i].payer_id=='201801329685'){
                                if(localStorage.getItem('account')=='1854320'||localStorage.getItem('account')=='1851638'){
                                    if(this.payersList[i].region == 'cn'){
                                        this.arrCn.push(this.payersList[i].payer_id)
                                    }else if(this.payersList[i].region == 'global'){
                                        this.arrGlobal.push(this.payersList[i].payer_id)
                                    }
                                    num++
                                }
                            }else if(this.payersList[i].payer_id=='354486963101'){
                                if(localStorage.getItem('account')=='1848589'||localStorage.getItem('account')=='1844225'){
                                    if(this.payersList[i].region == 'cn'){
                                        this.arrCn.push(this.payersList[i].payer_id)
                                    }else if(this.payersList[i].region == 'global'){
                                        this.arrGlobal.push(this.payersList[i].payer_id)
                                    }
                                    num++
                                }
                            }else if(this.payersList[i].agent&&this.payersList[i].agent.agent_id==localStorage.getItem('account')){
                                if(this.payersList[i].region == 'cn'){
                                    this.arrCn.push(this.payersList[i].payer_id)
                                }else if(this.payersList[i].region == 'global'){
                                    this.arrGlobal.push(this.payersList[i].payer_id)
                                }
                                // this.formInline.payer_id=this.payersList[i].payer_id;
                                num++;
                                // this.getData()
                            }
                        }
                        
                        if(num==0){
                            this.$message.warning('当前账户未绑定Payer！')
                        }else{
                            if(this.arrCn.length>0){
                                this.formInline.payer_id = this.arrCn.join(',');
                            }else{
                                this.formInline.payer_id = this.arrGlobal.join(',');
                                this.formInline.region = 'global'
                            }
                            this.getData()
                        }
                    }
                }, 500);
                
            }else if(this.curRole=='sales'){
                this.formInline.sales=localStorage.getItem('account')
                this.getData()
            }else if(this.curRole=='customer'){
                getLinkers({company_id:localStorage.getItem('account')}).then(res=>{
                    if(res.code==2000){
                        this.formInline.link_id=res.data.join(',');
                        this.getData()
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }else{
                if(this.$route.query.linkId){
                    this.formInline.link_id=this.$route.query.linkId;
                    this.formInline.month=this.$route.query.month;
                }
                this.getData();
            }
            this.getAgentsList()
        },
        methods:{
            //获取列表
            async getData() {
                this.loadingPage = true
                await getBillList(this.formInline).then(res => {
                    this.loadingPage = false
                    if(res.code ==2000) {
                        res.data.data.forEach(el=>{
                            el.canEdit=true;
                            el.canLocked=false;
                            if(el.locked==1){
                                el.canEdit=false;
                            }else if(el.ispaid==1&&el.isrecv==1&&el.locked!=1){
                                el.canLocked=true;
                            }
                            el.deadline=(new Date(el.deadline.toString().replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3")).getTime())/1000
                        })
                        this.tableData = res.data.data
                        this.pageparm.page = res.data.page;
                        this.pageparm.limit = res.data.limit;
                        this.pageparm.total = res.data.total;
                    }
                })
            },
            
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList=res.data.data;
                        this.agentMap=new Map();
                        this.agentsList.forEach(el=>{
                            this.agentMap.set(el.agent_id,el.company)
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            getLinkersList(id){
                var link_id='';
                if(id){
                    link_id=id;
                }
                getLinkerList({company:'',link_id:link_id,region:'',payer_id:'',agent_id:'',sales:'',page: 1,limit:999999}).then(res => {
                     if(res.code ==2000) {
                        if(res.data.data.length>0){
                            this.linkerList = res.data.data
                            id?this.linkerVisible=true:this.linkerVisible=false
                        }else{
                            this.$message.warning('未获取到当前Linker的详情！')
                        }
                     }else{
                        this.$message.error(JSON.stringify(res.msg));
                     }
                 })
            },  
            lock(obj){
                this.$confirm('账单锁定后不可再操作，继续锁定吗？','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    var param={};
                    if(obj){
                        param.id=obj.id
                    }else{
                        param.id=this.selected.join(',')
                    }
                    lockBill(param).then(res=>{
                        if(res.code==2000){
                            this.$message.success('锁定成功！');
                            this.getData();
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }).catch(err=>{})
            }, 
            changeStatus(obj){
                return new Promise((resolve, reject)=>{
                    try{
                        if(obj.isrecv){
                            this.$message.warning('当前账单已完成收款，无法操作！');
                            reject(false)
                        }else{
                            this.$confirm('确定更改账单为已收款状态吗？','提示',{
                                confirmButtonText:'确定',
                                cancelButtonText:'取消'
                            }).then(()=>{
                                setBillRecv({id:obj.id}).then(res=>{
                                    if(res.code==2000){
                                        this.$message.success(res.msg)
                                        this.getData()
                                    }else{
                                        reject(false)
                                    }
                                })
                                
                            }).catch(err=>{
                                reject(false)
                            })
                        }
                    }catch(err){
                        reject(false)
                    }
                })
            },
            changeStatus1(obj){
                return new Promise((resolve, reject)=>{
                    try{
                        if(obj.ispaid){
                            this.$message.warning('当前账单已完成支付，无法操作！');
                            reject(false)
                        }else{
                            this.$confirm('确定更改账单为已支付状态吗？','提示',{
                                confirmButtonText:'确定',
                                cancelButtonText:'取消'
                            }).then(()=>{
                                setBillPaid({id:obj.id}).then(res=>{
                                    if(res.code==2000){
                                        this.$message.success(res.msg)
                                        this.getData()
                                    }else{
                                        reject(false)
                                    }
                                })
                                
                            }).catch(err=>{
                                reject(false)
                            })
                        }
                    }catch(err){
                        reject(false)
                    }
                })
            },
            adjust(obj){
                getLinkerList({company:'',link_id:obj.LinkedAccountId,region:'',payer_id:'',agent_id:'',sales:'',page: 1,limit:999999}).then(res => {
                    if(res.code ==2000) {
                        if(res.data.data.length>0){
                            this.curBillId=obj.id;
                            this.curLinkId=obj.LinkedAccountId;
                            this.formData.discount=obj.discount;
                            this.formData.discount_agent=obj.discount_agent;
                            getRebate({link_id:obj.LinkedAccountId}).then(res=>{
                                if(res.code==2000){
                                    var rebateList=res.data;
                                    if(rebateList.length>0){//说明已经有过修改返点记录，下一步判断是link修改的还是服务修改的
                                        rebateList.forEach(el=>{
                                            if(el.service==''){
                                                this.formData.discount1=el.discount1
                                                this.formData.discount2=el.discount2
                                                this.formData.id=el.id;
                                            }
                                        })
                                    }else{//没有修改返点记录的话，使用原始的返点
                                        this.formData.discount1=obj.discount;
                                        this.formData.discount2=obj.discount_agent;
                                    }
                                    this.dialogVisible=true;
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));;
                                }
                            })
                        }else{
                            this.$confirm('当前Link在系统中未查询到，是否需要添加？','提示',{
                                confirmButtonText:'添加',
                                cancelButtonText:'取消'
                            }).then(()=>{
                                this.$router.push({path:'/linkerManage',query:{id:obj.LinkedAccountId}});
                            }).catch(err=>{})
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            adjustBudget(obj){
                this.curBillId=obj.id;
                var timer=setInterval(() => {
                    if(this.linkerList.length>0){
                        var num=0;
                        this.linkerList.forEach(el=>{
                            if(el.link_id==obj.LinkedAccountId){
                                num++;
                                this.formData1=el;
                                this.budgetVisible=true;
                            }
                        })
                        if(num==0){
                            this.$message.warning('请在Linker管理中添加该Linker！')
                        }
                        clearInterval(timer)
                    }
                }, 500);
            },
            // 预览
            preview(obj){
                this.curItem=obj;
                var obj1={};
                if(this.curRole=='agent'){
                    obj1={
                        link_id:obj.LinkedAccountId,
                        month:this.formInline.month,
                        role:'agent'
                    }
                }else if(this.curRole=='customer'){
                    obj1={
                        link_id:obj.LinkedAccountId,
                        month:this.formInline.month,
                        role:'client',
                        company_id:localStorage.getItem('account')
                    }
                }else if(this.curRole=='sales'){
                    obj1={
                        link_id:obj.LinkedAccountId,
                        month:this.formInline.month,
                        role:'sales'
                    }
                }else{
                    obj1={
                        link_id:obj.LinkedAccountId,
                        month:this.formInline.month,
                        role:'admin'
                    }
                }
                getBillDetail(obj1).then(res=>{
                    if(res.code==2000){
                        if(res.data.length>0){
                            this.billDetail=res.data;
                            this.billVisible=true;
                        }else{
                            this.$message.warning('账单数据为空！');
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));;
                    }
                })
            },
            download(obj){
                sendZhangdan({link_id:obj.LinkedAccountId,month:this.formInline.month,sendmail:0}).then(res=>{
                    if(res.code==2000){
                        var arr=res.data.fileurl.split(',');
                        arr.forEach((el,index)=>{
                            this.downloadFile(downloadUrl+el)
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));;
                    }
                })
            }, 
            downloadFile(url){
                const iframe = document.createElement("iframe");
                iframe.style.display = "none";  // 防止影响页面
                iframe.style.height = 0;  // 防止影响页面
                iframe.src = url;
                document.body.appendChild(iframe);
                setTimeout(()=>{
                    iframe.remove();
                }, 5 * 60 * 1000);
            },
            sendBill(obj){
                this.$confirm('确定发送该账单吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    sendZhangdan({link_id:obj.LinkedAccountId,month:this.formInline.month}).then(res=>{
                        if(res.code==2000){
                            this.$message.success('发送成功，请注意查收！');
                            this.getData()
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }).catch(err=>{})
            }, 
            cancel(){
                this.formData={
                    discount:0,
                    discount_agent:0,
                    discount1:0,
                    discount2:0
                }
                this.formData1={
                    link_id:'',
                    budget:'',
                    id:'',
                }
                this.billVisible=false;
                this.dialogVisible=false;
                this.budgetVisible=false;
            },
            submit(){
                if(this.formData.id){
                    adjustRebate({
                        link_id:this.curLinkId,
                        month:this.formInline.month,
                        service:'',
                        discount1:this.formData.discount1,
                        discount2:this.formData.discount2,
                        id:this.formData.id
                    }).then(res=>{
                        if(res.code==2000){
                            reCalcBill({link_id:this.curLinkId,month:this.formInline.month,bill_id:this.curBillId}).then(res=>{
                                if(res.code==2000){
                                    this.dialogVisible=false;
                                    this.getData();
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            })
                            
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{
                    addRebate({
                        link_id:this.curLinkId,
                        month:this.formInline.month,
                        service:'',
                        discount1:this.formData.discount1,
                        discount2:this.formData.discount2
                    }).then(res=>{
                        if(res.code==2000){
                            reCalcBill({link_id:this.curLinkId,month:this.formInline.month}).then(res=>{
                                if(res.code==2000){
                                    this.dialogVisible=false;
                                    this.getData();
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            })
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            editSubmit(){
                editLinker(this.formData1).then(res=>{
                    if(res.code==2000){
                        setBillBudget({id:this.curBillId,budget:this.formData1.budget}).then(res1=>{
                            if(res1.code==2000){
                                this.$message.success(res1.msg);
                                this.budgetVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(res1.msg);
                            }
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));;
                    }
                })
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            reset() {
                this.formInline = {
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    region:'cn',
                    month:'',
                    page: 1,
                    limit: 20,
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                let date = new Date();
                //获取当前年份的后一年
                let endY =date.getFullYear();
                //获取当前月
                let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
                if(Number(this.formInline.month.substring(this.formInline.month.length - 2))==Number(endM)){
                    this.isCurMonth=true;
                }else{
                    this.isCurMonth=false;
                }
                if(this.curRole=='agent'){
                    if(this.formInline.region=='cn'){
                        if(this.arrCn.length>0){
                            this.formInline.payer_id = this.arrCn.join(',')
                            this.getData()
                        }else{
                            this.$message.warning('请求结果为空！');
                            this.tableData=[]
                        }
                    }else{
                        if(this.arrGlobal.length>0){
                            this.formInline.payer_id = this.arrGlobal.join(',')
                            this.getData()
                        }else{
                            this.$message.warning('请求结果为空！');
                            this.tableData=[]
                        }
                    }
                }else{
                    this.getData()
                }
                // this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            selectionChange(val){
                this.selected=val;
            }
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss">
.link-dialog{
    .el-form-item__label{
        font-weight: bold;
    }
}
</style>
